import ScrollableTabs from "segments/desktop/core-components/scrollable-tabs/scrollable-tabs.js";
import classnames from "classnames";
import { StyledUsecasesGallery } from "./usecases-gallery-tabs-component.scss";

const UsecasesGalleryTabsComponent = (props) => {
  const {
    usecases,
    defaultSelectedTabLabel,
    alignToLogo,
    withDividerLine,
    selectedIconBackground,
    maxWidth,
    tabWidth,
    contentMarginTop,
    tabContentMaxWidth,
    iconSize
  } = props;

  const defaultSelectedTabIndex = usecases?.findIndex(
    (tab) => tab.label?.toLocaleLowerCase() === defaultSelectedTabLabel?.toLocaleLowerCase()
  );

  return (
    <StyledUsecasesGallery maxWidth={maxWidth}>
      <div
        className={classnames("usecases-gallery-tabs-component", {
          "align-to-logo": !!alignToLogo
        })}
      >
        <ScrollableTabs
          tabs={usecases}
          defaultSelectedTabIndex={defaultSelectedTabIndex}
          withDividerLine={withDividerLine}
          selectedIconBackground={selectedIconBackground}
          tabWidth={tabWidth}
          contentMarginTop={contentMarginTop}
          tabContentMaxWidth={tabContentMaxWidth}
          iconSize={iconSize}
        />
      </div>
    </StyledUsecasesGallery>
  );
};

export default UsecasesGalleryTabsComponent;
